import { createPortal } from "react-dom";
import { X } from "lucide-react";

export function ErrorPopup({
  title,
  description,
  onClose,
  open,
}: {
  description: string;
  title: string;
  onClose: () => void;
  open: boolean;
}) {
  return open
    ? createPortal(
        <div
          className={
            "bg-red-500 p-4 rounded-lg fixed top-2 right-2 z-50 text-white flex flex-col gap-1"
          }
        >
          <div className={"flex items-center justify-between gap-2"}>
            <h3 className={"font-medium"}>{title}</h3>
            <X className={"w-5 cursor-pointer"} onClick={onClose} />
          </div>
          <p>{description}</p>
        </div>,
        document.body,
      )
    : null;
}
